import React, { ReactNode } from 'react';

export const MainSort = ({ children, sortOrder }: { children: ReactNode; sortOrder: Array<number | undefined> }) => {
  const reactEls = React.Children.toArray(children);
  const combinedEls = reactEls.map((el, i) => {
    return { el, sortOrder: sortOrder[i] };
  });

  const newEls = combinedEls
    .sort(({ sortOrder: sortOrderA = 0 }, { sortOrder: sortOrderB = 0 }) => {
      return sortOrderA - sortOrderB;
    })
    .map((l) => l.el);

  return <>{newEls}</>;
};
